'use strict';
const hoverintent = require('hoverintent');

var flyouts = {
	timers: {},
	getFlyout: function ($flyoutLink) {
		var $flyout;
		var flyoutId = $flyoutLink.attr('data-flyout');
		var flyoutSelector = (flyoutId) ? '.flyout[data-flyout=' + flyoutId + ']' : '.flyout';

		$flyout = $flyoutLink.siblings(flyoutSelector);
		if (!$flyout.length) {
			$flyout = $flyoutLink.parent().parent().find(flyoutSelector);
		}

		return $flyout;
	},
	getLink: function ($flyout) {
		var $flyoutLink;
		var flyoutId = $flyout.attr('data-flyout');
		var linkSelector = (flyoutId) ? '.flyout-select[data-flyout=' + flyoutId + ']' : '.flyout-select';

		$flyoutLink = $flyout.siblings(linkSelector);
		if (!$flyoutLink.length) {
			$flyoutLink = $flyoutLink.parent().parent().find(linkSelector);
		}
		return $flyoutLink;
	},
	openFlyout: function ($flyout) {
		var $flyoutLink = flyouts.getLink($flyout);
		if ($flyoutLink) {
			$flyoutLink.addClass('active');
		}
		flyouts.closeAllFlyouts();

		// Hide other content for screen readers
		rp$('body > *').not($flyout).attr('aria-hidden', 'true');

		$flyout.attr('aria-modal', 'true').attr('tabindex', '-1').slideDown(function() {
			$flyout.focus(); // Focus on the flyout
		});

		flyouts.trapFocus($flyout); 
	},
	closeFlyout: function ($flyout) {
		var $flyoutLink = flyouts.getLink($flyout);
		if ($flyoutLink) {
			$flyoutLink.removeClass('active');
		}
		$flyout.slideUp(function() {
			// Restore accessibility for screen readers
			rp$('body > *').removeAttr('aria-hidden');
		});
	},
	closeAllFlyouts: function () {
		rp$('.flyout[data-flyout]').each(function () {
			flyouts.closeFlyout(rp$(this));
		});
	},
	handleLinkClick: function ($link) {
		var $flyout = this.getFlyout($link);
		if ($flyout.is(':visible')) {
			// $link.removeClass('active');
			// $flyout.slideUp();
			this.closeFlyout($flyout);
		} else {
			// $link.addClass('active');
			// $flyout.slideDown();
			this.openFlyout($flyout);
		}
	},
	handleFlyoutMouseEnter: function ($flyout) {
		var flyoutId = $flyout.attr('data-flyout');
		if (flyoutId) {
			window.clearTimeout(this.timers[flyoutId]);
			this.timers[flyoutId] = 'active';
			$flyout.focus();
		}
	},
	handleFlyoutMouseLeave: function ($flyout) {
		var flyoutId = $flyout.attr('data-flyout');
		if (flyoutId) {
			this.timers[flyoutId] = window.setTimeout(function () {
				flyouts.closeFlyout($flyout);
				// In this case, hide all instances of this type
				rp$('.flyout[data-flyout=' + flyoutId + ']').slideUp();
			}, 600);
		}
	},
	trapFocus: function($flyout) {
		$flyout.on('keydown', function(e) {
			var focusableElements = $flyout.find('a, button, input, [tabindex]:not([tabindex="-1"])');
			var firstElement = focusableElements.first();
			var lastElement = focusableElements.last();

			if (e.key === 'Tab') {
				if (e.shiftKey) { // Shift + Tab
					if (document.activeElement === firstElement[0]) {
						e.preventDefault();
						lastElement.focus();
					}
				} else { // Tab
					if (document.activeElement === lastElement[0]) {
						e.preventDefault();
						firstElement.focus();
					}
				}
			} else if (e.key === 'Escape') { // Close flyout on Escape key press
				flyouts.closeFlyout($flyout);
			}
		});
	},
	attachEvents: function () {
		rp$('.flyout-select').on('click', function () {
			flyouts.handleLinkClick(rp$(this));
		});
		rp$('.flyout').on('click', '.closeicon', function () {
			var $flyout = rp$(this).parent();
			flyouts.closeFlyout($flyout);
		});
		rp$('.flyout').on('mouseenter', function () {
			flyouts.handleFlyoutMouseEnter(rp$(this));
		});
		rp$('.flyout').on('mouseleave', function () {
			flyouts.handleFlyoutMouseLeave(rp$(this));
		});

		rp$('.flyout-select.flyout-hover').each((idx, ele) => {
			let $link = rp$(ele);

			/* Open Flyout
			.*-----------------------------------------*/
			const hoverIn = () => {
				let $flyout = flyouts.getFlyout($link);
				flyouts.openFlyout($flyout);
			};

			/* Close flyout (if flyout is not active)
			.*-----------------------------------------*/
			const hoverOut = () => {
				let $flyout = flyouts.getFlyout($link);
				var flyoutId = $flyout.attr('data-flyout');
				window.setTimeout(() => {
					if (this.timers[flyoutId] !== 'active') {
						flyouts.closeFlyout($flyout);
					}
				}, 100);
			};

			hoverintent(ele, hoverIn, hoverOut).options({
				sensitivity: 7,
				interval: 300
			});
		});
	}
};

module.exports = flyouts;
